import { render, staticRenderFns } from "./key-search.vue?vue&type=template&id=24dcc33e"
import script from "./key-search.vue?vue&type=script&lang=js"
export * from "./key-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24dcc33e')) {
      api.createRecord('24dcc33e', component.options)
    } else {
      api.reload('24dcc33e', component.options)
    }
    module.hot.accept("./key-search.vue?vue&type=template&id=24dcc33e", function () {
      api.rerender('24dcc33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/key-search.vue"
export default component.exports